import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TextEditorComponent, ParagraphData } from '../../../shared/public-api';

@Component({
  selector: 'admin-paragraph-section',
  templateUrl: './paragraph-section.component.html',
  styleUrls: ['./paragraph-section.component.scss'],
  imports: [CommonModule, FormsModule, TextEditorComponent],
})
export class ParagraphSectionComponent implements OnInit {
  @Input() sectionData: ParagraphData;
  @Output() sectionDataChange = new EventEmitter<any>();

  ngOnInit(): void {
    if (!this.sectionData) {
      this.sectionData = new ParagraphData();
    }
  }
}
